var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLicenseplate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "18px",
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08DBE201-7EDB-4968-88E5-395A901891F3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.500125,11.2500003 L2.500125,14.9763754 L5.09823068,14.9763754 L5.09448068,12.5000003 L19.9076514,12.5000003 L19.9026514,14.9763754 L22.500125,14.9763754 L22.500125,11.2500003 L18.7499998,11.2500003 L18.7499998,8.75000027 L22.500125,8.75000027 L22.500125,7.90791304 L21.8922667,7.49999997 L3.10798334,7.49999997 L2.500125,7.90791304 L2.500125,8.75000027 L6.04750005,8.75000027 L6.04750005,11.2500003 L2.500125,11.2500003 Z M5.4191365,4.99999997 L19.5811135,4.99999997 L18.3112167,2.522625 L6.68903328,2.522625 L5.4191365,4.99999997 Z M7.59826932,15.0000003 L7.60201932,17.4763754 L0.000124999997,17.4763754 L0.000124999997,6.57483726 L2.74769608,4.73103572 L5.16121672,0.0226250011 L19.8390333,0.0226250011 L22.2525539,4.73103572 L25.000125,6.57483726 L25.000125,17.4763754 L17.3975986,17.4763754 L17.4025986,15.0000003 L7.59826932,15.0000003 Z M8.74999983,11.2500003 L8.74999983,8.75000027 L16.2499998,8.75000027 L16.2499998,11.2500003 L8.74999983,11.2500003 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-Feedback",
    transform: "translate(-1351.000000, -205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feedback-form",
    transform: "translate(1220.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_licenseplate",
    transform: "translate(129.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(2.500000, 6.250000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLicenseplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_licenseplate.0f95096d18f196769776d27d62cdb2ac.svg";